var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import * as PropTypes from "prop-types";
import id from "@irati/utils/id";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import tracking from "@irati-tracking/platform";
import Link, { RouterLink } from "@irati/ui/src/Link";
import DesktopMenu from "./../DesktopMenu";
import UserMenuContext from "../../shared/UserMenuContext";
import UserMenuTitle from "./Title";
var UserMenu = /** @class */ (function (_super) {
    __extends(UserMenu, _super);
    function UserMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserMenu.prototype.render = function () {
        var _a = this.props, user = _a.user, formatMessage = _a.formatMessage;
        var _b = this.context, apps = _b.apps, appPath = _b.appPath;
        var idNamespace = id("user-menu", this.props);
        if (!authentication.isLoggedIn())
            return null;
        return (React.createElement(DesktopMenu, { id: idNamespace, tooltip: "usermenu", content: React.createElement(React.Fragment, null,
                React.createElement(UserMenuContext, { id: idNamespace }),
                appPath !== apps.ACCOUNT &&
                    React.createElement(React.Fragment, null,
                        React.createElement(RouterLink, { plain: true, id: id("link-profile", idNamespace), to: "/", onClick: function () { return tracking.clickHeaderMyAccount({ source: window.location.href }); }, app: apps.ACCOUNT },
                            React.createElement(FormattedMessage, { id: "platform.userMenu.header.account" })),
                        React.createElement(Link, { plain: true, id: id("link-help", idNamespace), target: "_blank", href: formatMessage({ id: "platform.help.header.href" }) },
                            React.createElement(FormattedMessage, { id: "platform.help.header.text" }))),
                React.createElement(RouterLink, { plain: true, id: id("link-logout", idNamespace), to: "/welcome/logout", app: apps.PLATFORM },
                    React.createElement(FormattedMessage, { id: "platform.userMenu.link.logout" }))) },
            React.createElement(UserMenuTitle, { user: user })));
    };
    return UserMenu;
}(Component));
UserMenu.contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
};
export default injectIntl(UserMenu);
